import { cubicOut } from 'eases-jsnext';

function fly(node, ref) {
	var delay = ref.delay; if ( delay === void 0 ) delay = 0;
	var duration = ref.duration; if ( duration === void 0 ) duration = 400;
	var easing = ref.easing; if ( easing === void 0 ) easing = cubicOut;
	var x = ref.x; if ( x === void 0 ) x = 0;
	var y = ref.y; if ( y === void 0 ) y = 0;

	var style = getComputedStyle(node);
	var opacity = +style.opacity;
	var transform = style.transform === 'none' ? '' : style.transform;

	return {
		delay: delay,
		duration: duration,
		easing: easing,
		css: function (t) { return ("\n\t\t\ttransform: " + transform + " translate(" + ((1 - t) * x) + "px, " + ((1 - t) * y) + "px);\n\t\t\topacity: " + (t * opacity)); }
	};
}

export default fly;
